import ButtonComponent from '../ui/ButtonComponent';

import { iconsPath } from '../../utils/imagePath';
import Card from '../ui/Card';

const LearningCenter = ({ closeModal }) => {
  const useCases = [
    'Interactive 3D',
    'Surface Tracking',
    'Image Tracking',
    'Location Tracking',
    'Area Tracking',
    'Virtual Spaces',
    'VR Training',
  ];

  const resources = ['Help & FAQ', 'Feedback'];

  return (
    <div className="bg-[#131418] h-fit  w-fit relative px-3 rounded-lg shadow-lg z-[999]">
      <div className="flex ">
        <div className="flex flex-col gap-3 border-r border-[#4D4D4D] w-[200px] py-2">
          {/* Header */}
          <h1 className="text-[#ffffff] text-[16px]">Learning Center</h1>
          <ButtonComponent
            className="flex items-center justify-start bg-[#31333A] hover:bg-[#31333A] !h-[26px] !rounded-[50px] max-w-[150px] text-[#D9D9D9] !font-normal text-[10px]"
            title="Getting Started"
          />

          {/* Use Cases */}
          <div className="flex flex-col gap-3 py-2">
            <h1>Use Cases</h1>
            {useCases.map((title, index) => (
              <ButtonComponent
                key={index}
                className="flex items-center justify-start bg-transparent hover:bg-transparent !h-[26px] !rounded-[50px] max-w-[150px] text-[#D9D9D9] !font-normal text-[10px] opacity-50"
                title={title}
              />
            ))}
          </div>

          {/* More Resources */}
          <div className="flex flex-col gap-3 py-2">
            <h1>More Resources</h1>
            {resources.map((title, index) => (
              <ButtonComponent
                key={index}
                className="flex items-center justify-start bg-transparent hover:bg-transparent !h-[26px] !rounded-[50px] max-w-[150px] text-[#D9D9D9] !font-normal text-[10px] opacity-50"
                title={title}
              />
            ))}
          </div>
        </div>
        <div className="p-5 flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <div className="relative w-[300px]">
              <img
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#767676] w-3 h-3"
                src={iconsPath?.group98Image}
                alt=""
              />
              <input
                className="bg-transparent border w-full pl-10 h-[26px] pr-3 py-2 rounded-[50px] text-[10px] border-[#767676] outline-none"
                type="text"
                placeholder="Search for tutorials, articles, and help"
              />
            </div>
            <div>
              <button
                onClick={closeModal}
                className="bg-[#31333A] rounded-full h-6 w-6 flex items-center justify-center"
              >
                <img src={iconsPath?.group95Image} alt="" />
              </button>
            </div>
          </div>
          <div>
            <h1 className="text-[#ffffff] text-[20px] font-bold">
              Getting Started
            </h1>
            <p className="text-[#BCBCBC] text-[8px] lih">
              Lets begin with some basics.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="flex flex-col items-start">
                <Card>
                  <div className="md:w-[150px] md:h-[120px] lg:w-[250px] lg:h-[170px] rounded-full"></div>
                </Card>
                <div className="py-2">
                  <p className="text-[#BCBCBC]  md:text-[9px] lg:text-[10px]">
                    Tutorial-5 Steps
                  </p>
                  <h1 className=" md:text-[12px] lg:text-[14px]">
                    How to use controllers
                  </h1>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningCenter;
